import { createSelector, createEntityAdapter } from "@reduxjs/toolkit";
import { apiSlice } from "../../../app/api/apiSlice";

const statesAdapter = createEntityAdapter({});

const initialState = statesAdapter.getInitialState();

export const statesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getStates: builder.query({
      query: () => "/states",
      validateStatus: (response, result) => {
        return response.status === 200 && !result.isError;
      },
      // keepUnusedDataFor: 5,
      transformResponse: (responseData) => {
        const loadedStates = responseData.map((state) => {
          state.id = state._id;
          return state;
        });
        return statesAdapter.setAll(initialState, loadedStates);
      },
      providesTags: (result, error, arg) => {
        if (result?.ids) {
          return [
            { type: "State", id: "LIST" },
            ...result.ids.map((id) => ({ type: "State", id })),
          ];
        } else return [{ type: "State", id: "LIST" }];
      },
    }),
    addNewState: builder.mutation({
      query: (initialStateData) => ({
        url: "/states",
        method: "POST",
        body: {
          ...initialStateData,
        },
      }),
      invalidatesTags: [{ type: "State", id: "LIST" }],
    }),
    updateState: builder.mutation({
      query: (initialStateData) => ({
        url: "/states",
        method: "PATCH",
        body: {
          ...initialStateData,
        },
      }),
      invalidatesTags: (result, error, arg) => [{ type: "State", id: arg.id }],
    }),
    deleteState: builder.mutation({
      query: ({ id }) => ({
        url: `/states`,
        method: "DELETE",
        body: { id },
      }),
      invalidatesTags: (result, error, arg) => [{ type: "State", id: arg.id }],
    }),
  }),
});

export const {
  useGetStatesQuery,
  useAddNewStateMutation,
  useUpdateStateMutation,
  useDeleteStateMutation,
} = statesApiSlice;

// returns the query result object
export const selectStatesResult = statesApiSlice.endpoints.getStates.select();

// // creates memoized selector
// const selectStatesData = createSelector(
//   selectStatesResult,
//   (statesResult) => statesResult.data // normalized state object with ids & entities
// );

// //getSelectors creates these selectors and we rename them with aliases using destructuring
// export const {
//   selectAll: selectAllStates,
//   selectById: selectStateById,
//   selectIds: selectStateIds,
//   // Pass in a selector that returns the states slice of state
// } = statesAdapter.getSelectors(
//   (state) => selectStatesData(state) ?? initialState
// );
